import { AspirationsToday } from '@/types.gql';
import { convertTime } from '@/utils/formatting';

interface Props {
  selectedAspiration?: AspirationsToday;
  timeZone: string;
  originalTimeZone: string;
  aspirationData: { category: string; left: number; right: number }[];
}

export const OpuSearchFormInfo = ({
  selectedAspiration,
  timeZone,
  originalTimeZone,
  aspirationData,
}: Props) => {
  const opuTime =
    selectedAspiration?.aspirationTime != null
      ? convertTime(
          selectedAspiration.aspirationTime,
          timeZone,
          originalTimeZone,
        )
      : '-';

  return (
    <div className="flex w-full flex-col gap-2 text-[11px]">
      <section
        style={{ backgroundColor: 'var(--color-background)' }}
        className="rounded p-1.5"
      >
        <Info label="OPU&nbsp;Time" value={opuTime} />
        <Info
          label="OPU&nbsp;Tech"
          value={selectedAspiration?.opuTech ?? '-'}
        />
        <Info
          label="Chute&nbsp;Tech"
          value={selectedAspiration?.chuteTech ?? '-'}
        />
      </section>

      <table
        style={{ backgroundColor: 'var(--color-background)' }}
        className="w-full rounded text-[11px]"
      >
        <thead>
          <tr className="bg-slate-100">
            <th className="px-1 py-0.5 text-left"></th>
            <th className="px-1 py-0.5 text-right">L</th>
            <th className="px-1 py-0.5 text-right">R</th>
          </tr>
        </thead>
        <tbody>
          {aspirationData.map((row) => (
            <tr key={row.category}>
              <td className="px-1 py-[2px]">{row.category}</td>
              <td className="px-1 py-[2px] text-right">{row.left}</td>
              <td className="px-1 py-[2px] text-right">{row.right}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <section
        style={{ backgroundColor: 'var(--color-background)' }}
        className="rounded p-1.5"
      >
        <span className="font-semibold">Comments:&nbsp;</span>
        <span>{selectedAspiration?.aspComments?.trim() || 'No comments'}</span>
      </section>
    </div>
  );
};

const Info = ({ label, value }: { label: string; value: string }) => (
  <div className="flex justify-between">
    <span
      className="font-semibold"
      dangerouslySetInnerHTML={{ __html: label }}
    />
    <span>{value}</span>
  </div>
);
